import { useCallback, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { BsFillXSquareFill } from 'react-icons/bs'
import { useSelector } from 'react-redux'
import Select from 'react-select'
import { ContactAddressType } from '../../../../../common/ContactAddress.type'
import { Group } from '../../../../../common/Group.type'
import userRole from '../../../../../config/userRole'
import { useProcessContactGroup } from '../../../../../hooks/fetch/contactGroup/useProcessContactGroup'
import { selectRole } from '../../../../../slices/authSlice'
import { useQueryContactGroup } from '../../../../../hooks/fetch/contactGroup/useQueryContactGroup'
import { contactGroupSerializer } from '../../../../../util/contactGroupSerializer'
import { GroupResponse } from '../../../../../common/GroupResponse'
import { useQueryContactAddress } from '../../../../../hooks/fetch/contactAddress/useQueryContactAddress'

const EditGroup = () => {
  const navigate = useNavigate()

  const role = useSelector(selectRole)
  let { id } = useParams()
  // console.log(`EditGroup() id=${id}`)

  const { data: queryAllContactAddresses, isError: isErrorAllContactAddress } = useQueryContactAddress()
  // console.log(`EditContact() isErrorAllContactAddress=${isErrorAllContactAddress}`)
  // console.log(`EditContact() queryAllContactAddresses=${JSON.stringify(queryAllContactAddresses)}`)

  const { data: queryContactGroups, isError: isErrorContactGroups } = useQueryContactGroup()
  // console.log(`EditGroup() isErrorContactGroups=${isErrorContactGroups}`)
  // console.log(`EditGroup() queryContactGroups=${JSON.stringify(queryContactGroups)}`)

  const getGroup = useCallback((localId: string | undefined, localIsErrorContactAddress: boolean, localAllContactAddresses: ContactAddressType[] | undefined, localIsErrorContactGroup: boolean, localContactGroups: GroupResponse[] | undefined): Group => {
    let wkGroup: Group
    if (!localIsErrorContactAddress && localAllContactAddresses && !localIsErrorContactGroup && localContactGroups) {
      wkGroup = localContactGroups.map((groupResponse) => {
        return contactGroupSerializer(groupResponse, localAllContactAddresses) as Group
      })
        .filter((group) => group.id === Number(localId))
        .pop() as Group
    }
    else {
      wkGroup = {} as Group
    }
    // console.log(`getGroup() wkGroup=${JSON.stringify(wkGroup)}`)
    return wkGroup
  }, [])
  const [group, setGroup] = useState(getGroup(id, isErrorAllContactAddress, queryAllContactAddresses, isErrorContactGroups, queryContactGroups))

  const [groupName, setGroupName] = useState(group?.groupName)
  const [groupAdmin, setGroupAdmin] = useState<ContactAddressType | undefined>(group?.groupAdmin)
  const [members, setMembers] = useState<ContactAddressType[]>(group?.members)

  let getMembersId = (localMembers: ContactAddressType[]): number[] => {
    return localMembers?.map((member) => member.id)
  }

  type selectOptions = { id: number; label: string | undefined; value: string; }

  let getContactsAdminOption = useCallback((localIsErrorContactAddress: boolean, localAllContactAddresses: ContactAddressType[] | undefined): selectOptions[] => {
    // console.log(`getContactsAdminOption() step-1`)
    // console.log(`getContactsAdminOption() localIsErrorContactAddress=${localIsErrorContactAddress} localAllContactAddresses=${JSON.stringify(localAllContactAddresses)}`)
    let wkContactsAdminOption: selectOptions[]
    if (!localIsErrorContactAddress && localAllContactAddresses) {
      // console.log(`getContactsAdminOption() step-2`)
      wkContactsAdminOption = localAllContactAddresses?.filter(
        (contact) =>
          contact.category === 'shared' && contact.contactType === '010',
      )
        .map((contact) => {
          return {
            id: contact.id,
            label: contact.contactName,
            value:
              contact.lastName +
              contact.firstName +
              contact.lastNameKana +
              contact.firstNameKana +
              contact.contactName +
              contact.id,
          }
        }) as selectOptions[]
    }
    else {
      wkContactsAdminOption = [{}] as selectOptions[]
    }
    // console.log(`getContactsAdminOption() step-3`)
    // console.log(`getContactsAdminOption() wkContactsAdminOption=${JSON.stringify(wkContactsAdminOption)}`)
    return wkContactsAdminOption
  }, [])
  let [contactsAdminOption, setContactsAdminOption] = useState<selectOptions[]>(getContactsAdminOption(isErrorAllContactAddress, queryAllContactAddresses))

  const getContactsOption = useCallback((localIsErrorContactAddress: boolean, localAllContactAddresses: ContactAddressType[] | undefined): selectOptions[] => {
    // console.log(`getContactsOption() step-0`)
    let wkContactsOption: selectOptions[]
    if (!localIsErrorContactAddress && localAllContactAddresses) {
      // console.log(`getContactsOption() step-1`)
      // console.log(`getContactsOption() allContactAddresses=${JSON.stringify(localAllContactAddresses)}`)
      wkContactsOption = localAllContactAddresses?.map((contact) => {
        return {
          id: contact.id,
          label: contact.contactName,
          value:
            contact.lastName +
            contact.firstName +
            contact.lastNameKana +
            contact.firstNameKana +
            contact.contactName +
            contact.id,
        }
      }) as selectOptions[]
    }
    else {
      wkContactsOption = [{}] as selectOptions[]
    }
    // console.log(`getContactsOption() step-2`)
    // console.log(`getContactsOption() wkContactsOption=${JSON.stringify(wkContactsOption)}`)
    return wkContactsOption
  }, [])
  let [contactsOption, setContactsOption] = useState<selectOptions[]>(getContactsOption(isErrorAllContactAddress, queryAllContactAddresses))

  const { updateContactGroup } = useProcessContactGroup()

  const editedContactGroup = {
    id,
    groupName: groupName,
    groupAdmin: groupAdmin?.id,
    members: members?.map((member) => member.id),
    groupCategory: group?.groupCategory,
  }

  useEffect(() => {
    // console.log(`EditGroup().useEffect() contactsOption更新 contactsAdminOption更新 group.groupName更新 group.groupAdmin更新 group.members更新 group.members更新`)
    // console.log(`EditGroup().useEffect() isErrorAllContactAddress=${isErrorAllContactAddress} queryAllContactAddresses=${queryAllContactAddresses} isErrorContactGroups=${isErrorContactGroups} queryContactGroups=${queryContactGroups}`)

    let wkGroup: Group = {} as Group
    let wkContactsOption: selectOptions[] = [{}] as selectOptions[]
    let wkContactsAdminOption: selectOptions[] = [{}] as selectOptions[]
    if (!isErrorAllContactAddress && queryAllContactAddresses && !isErrorContactGroups && queryContactGroups) {
      // console.log(`useEffect() step-3`)
      // console.log(`queryAllContactAddresses=${JSON.stringify(queryAllContactAddresses)} queryAllContactAddresses=${JSON.stringify(queryAllContactAddresses)}`)
      wkContactsOption = getContactsOption(isErrorAllContactAddress, queryAllContactAddresses)
      wkContactsAdminOption = getContactsAdminOption(isErrorAllContactAddress, queryAllContactAddresses)
      // console.log(`useEffect() wkContactsOption.length=${wkContactsOption.length} wkContactsAdminOption.length=${wkContactsAdminOption.length} wkContactsOption=${JSON.stringify(wkContactsOption)} wkContactsAdminOption=${JSON.stringify(wkContactsAdminOption)}`)
      setContactsOption(wkContactsOption)
      setContactsAdminOption(wkContactsAdminOption)
      //// console.log(`useEffect() contactsOption.length=${contactsOption.length} contactsAdminOption.length=${contactsAdminOption.length} contactsOption=${JSON.stringify(contactsOption)} contactsAdminOption=${JSON.stringify(contactsAdminOption)}`) // useEffect監視対象に contactsOption, contactsAdminOption が必要 
      wkGroup = getGroup(id, isErrorAllContactAddress, queryAllContactAddresses, isErrorContactGroups, queryContactGroups)
      setGroup(wkGroup)
    }
    // console.log(`useEffect() step-4`)

    setGroupName(wkGroup?.groupName)
    setGroupAdmin(wkGroup?.groupAdmin)
    setMembers(wkGroup?.members)

    // console.log(`EditGroup().useEffect() group.groupName=${wkGroup?.groupName} group.groupAdmin=${JSON.stringify(wkGroup?.groupAdmin)} wkContactsOption=${JSON.stringify(wkContactsOption)} wkContactsAdminOption=${JSON.stringify(wkContactsAdminOption)} group.members=${JSON.stringify(wkGroup?.members)}`)
  }, [
    id,
    queryAllContactAddresses,
    queryContactGroups,
    getContactsAdminOption,
    getContactsOption,
    getGroup,
    isErrorAllContactAddress,
    isErrorContactGroups
  ])

  // useEffect(() => {
  //   console.log(`useEffect() contactsOption更新 contactsAdminOption更新`)
  // }, [contactsOption, contactsAdminOption])

  return (
    <div className="box inner-box stack">
      <span
        className="cursor-pointer upper-right"
        onClick={() => navigate('/contactGroup')}
      >
        <BsFillXSquareFill size={'1rem'} />
      </span>

      <span>
        <label htmlFor="groupName" className="d-block">
          グループ名：<span className="text-light bg-danger badge">必須</span>
        </label>
        <input
          type="text"
          id="groupName"
          autoComplete="none"
          style={{ width: '100%' }}
          value={groupName}
          onChange={(e) => setGroupName(e.target.value)}
        />
      </span>

      {role === userRole['カンパニー管理者'] && (
        <span className="select:medium">
          <label className="d-block">グループ管理者：</label>
          <Select
            id="groupAdmin"
            options={contactsAdminOption}
            onChange={(e) => {
              const target = queryAllContactAddresses?.filter(
                (contact) => contact.id === e?.id
              )[0]
              setGroupAdmin(target)
            }}
            value={contactsOption.filter(
              (contact) => contact.id === groupAdmin?.id
            )}
            isSearchable
            isClearable
          />
        </span>
      )}

      <span className="select:medium">
        <label className="d-block">メンバー：</label>
        <Select
          options={contactsOption}
          onChange={(e) => {
            const addContacts = e.map(
              ({ id }) =>
                queryAllContactAddresses?.filter((contact) => contact.id === id)[0]
            )
            // console.log(`select.onChange() addContacts=${JSON.stringify(addContacts)}`)
            // console.log(`select.onChange() e=${JSON.stringify(e)}`)
            if (addContacts !== undefined) {
              setMembers(addContacts as ContactAddressType[])
            }
            else {
              setMembers([{}] as ContactAddressType[])
            }
          }}
          value={contactsOption?.filter((contact) =>
            getMembersId(members)?.includes(contact.id)
          )}
          isMulti
          isSearchable
          isClearable
        />
      </span>

      <hr />

      <div className="switcher">
        <button
          type="button"
          className="submitButton"
          onClick={(e) => {
            updateContactGroup(e, editedContactGroup, '/contactGroup')
          }}
          disabled={!groupName}
        >
          グループを保存
        </button>

        <button
          type="button"
          className="submitButton btn-danger ms-3"
          onClick={() => navigate('/contactGroup')}
        >
          キャンセル
        </button>
      </div>
    </div>
  )
}

export default EditGroup
